import { createGlobalStyle } from 'styled-components';
import { semanticColors, typography } from '../styles/tokens';
import pretendardRegular from '../assets/fonts/pretendard/Pretendard-Regular.subset.woff2';
import pretendardMedium from '../assets/fonts/pretendard/Pretendard-Medium.subset.woff2';
import pretendardSemiBold from '../assets/fonts/pretendard/Pretendard-SemiBold.subset.woff2';
import pretendardBold from '../assets/fonts/pretendard/Pretendard-Bold.subset.woff2';

// 폰트 파일은 investor/my-space/startup 3개 스페이스가 공유하는 src/common(서브모듈)에 둔다.
// public/ 폴더는 앱별로 분리되어 서브모듈로 공유되지 않으므로, 여기서 import해서
// Vite 에셋 파이프라인으로 각 앱 빌드에 포함시켜야 3개 앱이 동일한 폰트를 쓸 수 있다.
const GlobalStyle = createGlobalStyle`
  /* 자체 호스팅 Pretendard — 외부 CDN(Google Fonts) 의존성 제거, 사내망/해외 접속 환경에서도 안정적으로 로드됨 */
  @font-face {
    font-family: 'Pretendard';
    src: url(${pretendardRegular}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Pretendard';
    src: url(${pretendardMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Pretendard';
    src: url(${pretendardSemiBold}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Pretendard';
    src: url(${pretendardBold}) format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @layer base {
    :root {
      --font-body: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Apple SD Gothic Neo',
        'Noto Sans KR', 'Malgun Gothic', 'Helvetica Neue', sans-serif;
    }
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Apple SD Gothic Neo',
      'Noto Sans KR', 'Malgun Gothic', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${semanticColors.background.primary};
    color: ${semanticColors.text.primary};
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  h1, h2, h3, h4, h5, h6, p, figure, blockquote, dl, dd {
    margin: 0;
  }

  h1 {
    ${typography.heading.h1}
  }

  h2 {
    ${typography.heading.h2}
  }

  h3 {
    ${typography.heading.h3}
  }

  h4 {
    ${typography.heading.h4}
  }

  h5 {
    ${typography.heading.h5}
  }

  h6 {
    ${typography.heading.h6}
  }
  
  .sub_title_1 {
    ${typography.subtitle.subtitle1}
  }

  .sub_title_2 {
    ${typography.subtitle.subtitle2}
  }

  .paragraph_1_default {
    ${typography.paragraph.p1.default}
  }

  .paragraph_1_medium {
    ${typography.paragraph.p1.medium}
  }

  .paragraph_2_default {
    ${typography.paragraph.p2.default}
  }

  .paragraph_2_medium {
    ${typography.paragraph.p2.medium}
  }
  
  .body_regular_16 {
    ${typography.paragraph.p1.default}
  }
  
`;

export default GlobalStyle;
